import { SeatWithLocationDataType } from "@shared/modules/seating/types/seating-types";
import { useTranslation } from "@shared/utils/internationalization";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Modal from "@ui-kit/overlays/Modal/Modal.web";
import { useMemo } from "react";
import ItemSelectModalSelectCustomerScreen from "@app-contexts/dashboard/features/box-office/seating/components/ItemSelectModal/ItemSelectModalSelectCustomerScreen.web";
import Button from "@shared/components/ui-kit/form/Button/Button.web";
import DefaultSeatSelect from "./DefaultSeatSelect/DefaultSeatSelect.web";
import {
  DefaultSeatSelectModalProps,
  MapItemType,
} from "./DefaultSeatSelectModal.props";
import { useDefaultSeatSelectModal } from "./useDefaultSeatSelectModal";

const DefaultSeatSelectModal = (props: DefaultSeatSelectModalProps) => {
  const { t } = useTranslation("seating");

  const { itemsOnSeat, isOpen, seatingEvent, resolve } = props;
  const { $data } = itemsOnSeat;

  const {
    seatItems,
    itemPermission,
    selectItemPermission,
    cancelModal,
    customerSelected,
    handleSelectCustomer,
    handleUnselectCustomer,
    handleScreen,
    screen,
    itemGroups,
    areAllRenewalItemGroups,
  } = useDefaultSeatSelectModal(props);

  const headerText = useMemo(
    () =>
      t("Section {{section}}, Row {{row}}, Seat {{seat}}", {
        section: ($data as SeatWithLocationDataType).segment_identifier,
        row: ($data as SeatWithLocationDataType).location_identifier,
        seat: $data?.identifier,
      }),
    [$data, t]
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={cancelModal}
      size="3xl"
      isCentered
      variant="interactive"
      scrollBehavior="inside"
    >
      <Modal.Header alignItems="center">{headerText}</Modal.Header>
      <Modal.Body>
        {screen === "select-item" && (
          <Flex
            data-testid="default-seat-select-modal"
            w="full"
            direction="column"
            gap="md"
            mt="none"
          >
            {seatItems?.map((item: MapItemType) => (
              <DefaultSeatSelect
                key={item.id}
                item={item}
                selectItemPermission={selectItemPermission}
                handleScreen={handleScreen}
                areAllRenewalItemGroups={areAllRenewalItemGroups}
                {...props}
              />
            ))}
          </Flex>
        )}
        {seatingEvent && screen === "select-customer" && (
          <ItemSelectModalSelectCustomerScreen
            seatingEvent={seatingEvent}
            itemGroups={itemGroups}
            customerSelected={customerSelected}
            handleSelectCustomer={handleSelectCustomer}
            handleUnselectCustomer={handleUnselectCustomer}
          />
        )}
      </Modal.Body>
      {screen === "select-customer" && areAllRenewalItemGroups && (
        <Modal.Footer>
          <Button.Solid
            data-testid="item-select-modal-select-customer-done-button"
            onClick={() => {
              if (itemPermission) {
                resolve({
                  ...itemPermission,
                  itemGroupId: customerSelected?.id,
                });
              }
            }}
          >
            {t("Done")}
          </Button.Solid>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default DefaultSeatSelectModal;
